import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../lib/utils';

function ConfirmationDialog({ isOpen, title, message, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[3000] flex items-center justify-center bg-gallery-900/70 backdrop-blur-md">
      <div 
        className={cn(
          "bg-gallery-50 rounded-2xl p-8 max-w-md mx-4",
          "shadow-gallery-xl border border-gallery-200",
          "transform transition-all duration-300 ease-out"
        )}
      >
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="p-3 rounded-full bg-warm-100 border border-warm-200">
            <AlertTriangle className="w-6 h-6 text-warm-700" />
          </div>
        </div>

        {/* Title */}
        <h3 className="font-serif text-xl font-semibold text-gallery-900 text-center mb-4">
          {title}
        </h3>
        
        {/* Message */}
        <p className="text-gallery-600 text-center mb-8 leading-relaxed">
          {message}
        </p>
        
        {/* Actions */}
        <div className="flex space-x-3">
          <button
            onClick={onCancel}
            className={cn(
              "flex-1 px-4 py-3 rounded-lg border-2 border-gallery-300",
              "bg-gallery-100 text-gallery-700 font-medium",
              "hover:bg-gallery-200 hover:border-gallery-400",
              "transition-all duration-200"
            )}
          >
            {t('cancel')}
          </button>
          
          <button
            onClick={onConfirm}
            className={cn(
              "flex-1 px-4 py-3 rounded-lg border-2 border-accent-600",
              "bg-accent-600 text-white font-medium",
              "hover:bg-accent-700 hover:border-accent-700",
              "transition-all duration-200 shadow-sm hover:shadow-md"
            )}
          >
            {t('confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationDialog;